import {useCallback, useRef, useState} from "react";

export function useGeoData(){
  const [geoUrl, setGeoUrl] = useState("")
  const [jsonState, setJsonState] = useState({})
  const [allCities, setAllCities] = useState([])

  const geoJsonCacheRef = useRef({})

  const loadStateGeoJson = useCallback(async (uf) => {
    const cacheKey = `state-${uf}`
    if (geoJsonCacheRef.current[cacheKey]){
      const cached = geoJsonCacheRef.current[cacheKey]
      setGeoUrl(cached.url)
      setJsonState(cached.data)
      setAllCities(cached.cities)
      return cached
    }

    const url = `jsons/geojs-${uf}.json`
    const data = await fetch(url).then(res => res.json())
    const cities = data.features.map(f => f.properties.name)

    geoJsonCacheRef.current[cacheKey] = {url, data, cities}

    setGeoUrl(url)
    setJsonState(data)
    setAllCities(cities)

    return {url, data, cities}
  }, [])

  const loadRegionGeoJson = useCallback(async(statesInRegion) => {
    const cacheKey = `region-${statesInRegion.sort().join(",")}`

    if (geoJsonCacheRef.current[cacheKey]){
      const cached = geoJsonCacheRef.current[cacheKey]
      setGeoUrl(cached.urls)
      setJsonState(cached.data)
      setAllCities(cached.allCities)
      return cached
    }

    const combinedFeatures = []
    const allCities = []
    const urls = []

    for (const uf of statesInRegion){
      const url = `jsons/geojs-${uf}.json`
      urls.push(url)
      const data = await fetch(url).then(res => res.json())

      const featuresWithUf = data.features.map(f => ({
        ...f,
        properties: { ...f.properties, uf }
      }))

      combinedFeatures.push(...featuresWithUf)
      allCities.push(...data.features.map(c => `${c.properties.name} - ${uf}`))
    }

    const mergedGeoJson = {
      type: "FeatureCollection",
      features: combinedFeatures
    }

    const result = {urls, data: mergedGeoJson, allCities}

    geoJsonCacheRef.current[cacheKey] = result

    setGeoUrl(statesInRegion.map(uf => `jsons/geojs-${uf}.json`))
    setJsonState(mergedGeoJson)
    setAllCities(allCities)

    return result
  }, [])

  return {
    geoUrl,
    jsonState,
    allCities,
    loadStateGeoJson,
    loadRegionGeoJson
  }
}